import { Outlet } from 'react-router'
import WebAdminNav from 'src/Components/WebAdminNav'

const WebAdmin = () => {
  return (
    <WebAdminNav>
      <Outlet />
    </WebAdminNav>
  )
}

export default WebAdmin
